// extracted by mini-css-extract-plugin
module.exports = {"tags":"client-page-tags__16Mdu"};